import { Grid2 as Grid, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useStringsContext } from '../../../../contexts/strings';

function Variable({
  name,
  value,
  onChange,
}: {
  name: string;
  value: string;
  onChange: (oldKey: string, key: string, value: string) => void;
}) {
  const { strings } = useStringsContext();
  const [variableName, setVariableName] = useState(name);
  const [variableValue, setVariableValue] = useState(value);

  const onNameChange = (e: any) => {
    setVariableName(e.target.value);
    onChange(name, e.target.value, variableValue);
  };

  const onValueChange = (e: any) => {
    setVariableValue(e.target.value);
    onChange(name, variableName, e.target.value);
  };
  return (
    <Grid container spacing={2}>
      <Grid size={6}>
        <TextField
          label={strings.faq.variableName}
          margin="normal"
          fullWidth
          variant="outlined"
          value={variableName}
          onChange={onNameChange}
        />
      </Grid>
      <Grid size={6}>
        <TextField
          label={strings.faq.variableValue}
          margin="normal"
          fullWidth
          variant="outlined"
          value={variableValue}
          onChange={onValueChange}
        />
      </Grid>
    </Grid>
  );
}

export default Variable;
